import React from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { StudentSignUpHeroSection } from '../StudentSignUpHeroSection';
import { StudentSignUpFormSection } from '../StudentSignUpFormSection';
export const StudentSignUp = () => {
  return <div className="w-full min-h-screen bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50] text-white font-sans" data-id="element-7889">
      <Navbar data-id="element-7890" />
      <main data-id="element-7891">
        <StudentSignUpHeroSection data-id="element-7892" />
        <StudentSignUpFormSection data-id="element-7893" />
      </main>
      <Footer data-id="element-7894" />
    </div>;
};